import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.74935 2.5C2.59876 2.5 1.66602 3.43274 1.66602 4.58333V14.5833C1.66602 15.7339 2.59876 16.6667 3.74935 16.6667H16.2493C17.3999 16.6667 18.3327 15.7339 18.3327 14.5833V7.08333C18.3327 5.93274 17.3999 5 16.2493 5H10.8913C10.4734 5 10.0831 4.79112 9.85126 4.44338L9.17415 3.42771C8.78776 2.84813 8.13728 2.5 7.44071 2.5H3.74935Z",
      fill: "#489ffa",
      stroke: "#489ffa",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      id: "path-circle",
      d: "M16 21.75C19.1756 21.75 21.75 19.1756 21.75 16C21.75 12.8244 19.1756 10.25 16 10.25C12.8244 10.25 10.25 12.8244 10.25 16C10.25 19.1756 12.8244 21.75 16 21.75Z",
      fill: "#489ffa",
      stroke: "#F6F6F6",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }